import React, { useEffect, useState, useRef, useCallback } from "react";
import "../../assets/css/style.css";
import "../../assets/css/login.css";
import "../../assets/css/save.css";
import { getUserDetails } from "../../services/apiProfile";
import "../../assets/css/style_new.css";
import playimg from "../../assets/img/play-circles.svg"
import ReportPost from "../Posts/popups/ReportPost";
import MakeFavourite from "../Posts/popups/MakeFavourite";
import ListFeed from "../Posts/ListFeed";
import CreatePost from "../Posts/CreatePost";
import Spinner from "../../commonComponents/Spinner";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import Confirmpopup from "../../commonComponents/Confirmpopup";
import CreateDiscussion from "./CreateDiscussion";
import {

  savePostComment, savePostShortlist, savePostLike, deletePost
} from "../../services/apiPosts";
import PodCast from "./PodCastPopup";

const SavedPost = () => {
  const MAX_COMMENT_LENGTH = 2000;
    const [characterLimit, setCharacterLimit] = useState({
      isOverLimit: false,
      remaining: MAX_COMMENT_LENGTH,
      limitedText: ''
    });
  const sliderRef = useRef(null);
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [loading, setLoading] = useState(true);
  const [Feeds, setFeeds] = useState([]);
  const [podCast, setPodCast] = useState([]);
  const [comment, setComment] = useState({});
  const [show, setShow] = useState(false);
  const [showreport, setShowReport] = useState(false);
  const [showfav, setFavourite] = useState(false);
  const [reportId, setReportId] = useState(false);
  const [favouriteUserId, setFavouriteUserId] = useState(false);
  const [favourites, setFavourites] = useState({});
  const [likedPosts, setLikedPosts] = useState({});
  const [savedPost, setsavedPosts] = useState({});
  const [FavStatus, setFavStatus] = useState();
  const [EditStatus, setEditStatus] = useState(false);
  const [isPodCastPlay, setIsPodCastPlay] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState('');
  const [EditFeed, setEditFeed] = useState([]);
  const [isSucess, SetSucess] = useState(false);
  const [ResponseMessage, SetResponseMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [offset, setOffset] = useState(0);
  const[isConfirm,setConfirm]=useState(false);
  const[DeletPostid,setDeltePostId]=useState('');
  const[DiscussionStatus,setDiscussionStatus] = useState(false);
  const[Organiationid,setOrganiationId]=useState('');
  const [hasMore, setHasMore] = useState(true); // pagination 
  const limit = 20; // Number of posts per fetch

  const MEDIA_BASE_URL = process.env.REACT_APP_IMAGE_URL;
  const DEFAULT_NO_IMAGE_PLACEHOLDER = process.env.REACT_DEFAULT_NO_IMAGE_URL;

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -sliderRef.current.offsetWidth / 2,
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: sliderRef.current.offsetWidth / 2,
        behavior: 'smooth',
      });
    }
  };
  const handlePlay = (url) => {
    setCurrentVideoUrl(url);
    setIsPodCastPlay(true);
  };

  const handleClose = () => {
    setIsPodCastPlay(false);
    setCurrentVideoUrl('');
  };
  const lastPostRef = useRef(null);
  const OpenPopup = () => {
    setOpen(true);
  }
  const ClosePopup = () => {
    setOpen(false);
    setEditStatus(false);
  }

  useEffect(() => {
    let listpayloadSave = {
      userid: userData._id,
      offset: offset ? offset : 0,
      limit: limit ? limit : 10
    };
    localStorage.setItem("postpayload", JSON.stringify(listpayloadSave));
    setOffset(0); // Reset offset
    setHasMore(true); // Reset hasMore
    setFeeds([]); // Clear existing feeds
    fetchAllFeeds(listpayloadSave);
  }, []);
  /* for pagination */
  const loadMoreFeeds = async (loadmorePayload) => {
    if (!hasMore || loading) return;
    setLoading(true);
    localStorage.setItem('postpayload', JSON.stringify(loadmorePayload));
    let listFeeds = await getUserDetails(loadmorePayload);
    if (listFeeds.status === true) {
      if (listFeeds.savedPosts.length === 0) {
        setHasMore(false); // No more posts to load
      } else {

        setFeeds((prevFeeds) => [...prevFeeds, ...listFeeds.savedPosts]); // Append new posts
        setOffset(loadmorePayload.offset); // Update offset
        const initialLikedPosts = {};
        const intialFavourites = {};
        listFeeds.savedPosts.forEach(post => {
          // Check if userlike array contains an object with isliked equal to 1
          if (post.userlike.length > 0 && post.userlike[0].isliked === 1) {
            initialLikedPosts[post._id] = true; // User liked the post
          } else {
            initialLikedPosts[post._id] = false; // User did not like the post
          }
          if (post.favouritemember.length > 0 && post.favouritemember[0].isfavourite === 1) {
            intialFavourites[post.user[0]._id] = true;
          } else {
            intialFavourites[post.user[0]._id] = false;
          }
        });
        setLikedPosts(initialLikedPosts);
        setFavourites(intialFavourites);


      }


    }
    setLoading(false);

  };

  const isVideoFile = (url) => {
    if (!url) return false;
    const videoExtensions = /\.(mp4|webm|ogg|avi|mov|flv|wmv|mkv)$/i;
    return videoExtensions.test(url.toLowerCase());
  };

  const isImageFile = (url) => {
    if (!url) return false;
    const imageExtensions = /\.(jpeg|jpg|gif|png|bmp|webp|svg)$/i;
    return imageExtensions.test(url.toLowerCase());
  };

  const generateVideoThumbnail = useCallback((videoUrl) => {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.src = videoUrl;
      video.crossOrigin = 'anonymous';
      video.preload = 'metadata';
      video.muted = true;
      video.style.display = 'none'; // Hide video element
      video.currentTime = 0.5; // Try to get a frame from 0.5 seconds into the video

      let timeoutId = null;

      const cleanup = () => {
        if (timeoutId) clearTimeout(timeoutId);
        video.removeEventListener('loadedmetadata', onLoadedMetadata);
        video.removeEventListener('seeked', onSeeked);
        video.removeEventListener('error', onError);
        video.removeEventListener('canplaythrough', onCanPlayThrough);
        if (video.parentNode) {
          video.parentNode.removeChild(video);
        }
      };

      const onLoadedMetadata = () => {
        video.currentTime = Math.min(1, video.duration / 2 || 0);
      };

      const onSeeked = () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        try {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL('image/jpeg'));
        } catch (e) {
          console.error("Error drawing video to canvas (CORS/tainted canvas likely):", videoUrl, e);
          resolve(DEFAULT_NO_IMAGE_PLACEHOLDER + '?text=Video+CORS+Error');
        } finally {
          cleanup();
          canvas.remove();
        }
      };

      const onError = (e) => {
        console.error("Error loading video for thumbnail:", videoUrl, e);
        resolve(DEFAULT_NO_IMAGE_PLACEHOLDER + '?text=Video+Load+Error');
        cleanup();
      };

      const onCanPlayThrough = () => {
        if (timeoutId) clearTimeout(timeoutId);
      };

      video.addEventListener('loadedmetadata', onLoadedMetadata);
      video.addEventListener('seeked', onSeeked);
      video.addEventListener('error', onError);
      video.addEventListener('canplaythrough', onCanPlayThrough);

      document.body.appendChild(video);

      timeoutId = setTimeout(() => {
        console.warn("Video thumbnail generation timeout for:", videoUrl);
        resolve(DEFAULT_NO_IMAGE_PLACEHOLDER + '?text=Video+Timeout');
        cleanup();
      }, 7000);
    });
  }, [DEFAULT_NO_IMAGE_PLACEHOLDER]);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore) {
          const newOffset = offset + limit;
          const storedPayload = localStorage.getItem('postpayload');
          if (!storedPayload) return; // 
          const listpayloadSave = JSON.parse(storedPayload);
          listpayloadSave.offset = newOffset;
          loadMoreFeeds(listpayloadSave);
        }
      },
      { threshold: 0.1 }
    );

    if (lastPostRef.current) {
      observer.observe(lastPostRef.current);
    }

    return () => {
      if (lastPostRef.current) {
        observer.unobserve(lastPostRef.current);
      }
    };
  }, [hasMore, offset, loading]);


  const showReport = (postid) => {
    setShow(true);
    setShowReport(true);
    setReportId(postid)
  }
  const HideReport = () => {
    setShowReport(false);
  }

  const showFavourite = (userId, arraylength) => {
    setFavourite(true);
    setFavouriteUserId(userId);
    setFavStatus(favourites[userId] || false);

  }
  const HideFavourite = () => {
    setFavourite(false);
  }
  const toggleFavourite = (userId, newstatus) => {
    const isUsrId = favourites[userId];
    setFavourites((prevFavourites) => ({
      ...prevFavourites,
      [userId]: newstatus
    }));
  };

  const handleshortlist = async (postid) => {
    let shortlistpayload = { postid: postid, userid: userData._id }
    let shortResponse = await savePostShortlist(shortlistpayload);
    if (shortResponse.status === true) {
      setsavedPosts((prevSavedPosts) => ({
        ...prevSavedPosts,
        [postid]: !prevSavedPosts[postid], // Toggle the saved status
      }));
      SetSucess(true);
      SetResponseMessage("Post is saved!");


    }

  }
  const handleLike = async (postid) => {
    const isLiked = likedPosts[postid]; // Get current liked status
    let likePayload = { postid: postid, userid: userData._id };
    let likeresponse = await savePostLike(likePayload);
    if (likeresponse.status === true) {
      // Update likedPosts state
      setLikedPosts((prevLikes) => ({
        ...prevLikes,
        [postid]: !isLiked, // Toggle the liked status
      }));
    }
  };

  const handleDelete = async (postid) => {
      setConfirm(false);
    let deletepayload = { postid: postid };
    let response = await deletePost(deletepayload);
    if (response.status === true) {
      SetSucess(true);
      SetResponseMessage("Post is Deleted!");
      setFeeds(prevFeeds => prevFeeds.filter(post => post._id !== postid));
     
    }

  }
  const DeletPost = async (postid) => {
       setConfirm(true);
        setDeltePostId(postid);
  };
  const handleEdit = (feed) => {
     if(feed.organizationId){
      setOrganiationId(feed.organizationId);
       setDiscussionStatus(true); 
     }else{
      setDiscussionStatus(false); 
       
     }
    
    setEditFeed(feed);
    setEditStatus(true);
    setOpen(true);
  }

  const handleCommentChange = (postId, value) => {
    setComment((prevComments) => ({
      ...prevComments,
      [postId]: value,
    }));
  };
  const handleCommentSubmit = async (postid) => {

    let commentPayload = { comment: comment[postid], postid: postid, userid: userData._id }
    let response = await savePostComment(commentPayload);
    if (response.status === true){

       setComment((prevComments) => ({
        ...prevComments,
        [postid]: '',
      }));

    }else{
             SetSucess(true);
             SetResponseMessage(response.message);

    }
     

  };

  const handleCommentClear = (postId) => {
    setComment((prevComments) => ({
      ...prevComments,
      [postId]: '',
    }));
  }
 const getYouTubeVideoId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};
  const fetchAllFeeds = async (listpayloadSave) => {
    setHasMore(true);
    setLoading(true);
    setFeeds([]); // Clear existing feeds when fetching new ones
    setOffset(0); // Reset offset
    let listFeeds = await getUserDetails(listpayloadSave);
    if (listFeeds.status === true) {
      

      if (listFeeds?.savedPodcasts) {
       const processedItemsPromises = listFeeds?.savedPodcasts.map(async (item) => {
      let thumbnailUrl = DEFAULT_NO_IMAGE_PLACEHOLDER;
      let videoUrl = null;
const mediaType = item.podcastId?.mediaType?.toLowerCase();
      if (mediaType === "youtube" && item.podcastId?.youtubeurl) {
        const videoId = getYouTubeVideoId(item.podcastId?.youtubeurl);
        if (videoId) {
          thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
          videoUrl = `https://www.youtube.com/embed/${videoId}`;
        }
      } else if (mediaType === "video" && item.podcastId?.videourl) {
        const fullMediaUrl = `${MEDIA_BASE_URL}${item.podcastId?.videourl}`;
        
        
        videoUrl = fullMediaUrl;
        thumbnailUrl = await generateVideoThumbnail(fullMediaUrl);
      } else if (isImageFile(item.podcastId?.videourl)) {
        thumbnailUrl = `${MEDIA_BASE_URL}${item.podcastId?.videourl}`;
      }

      return {
        id: item.podcastId?._id,
        videoUrl,
        imageUrl: thumbnailUrl,
        isYouTube: item.podcastId?.mediaType === "youtube",
        title: item.podcastId?.title,
        description: item.podcastId?.description || 'No description available.',
        savedpodcast: item.podcastId?.savedpodcast || []
      };
    });

    const fetchedItems = await Promise.all(processedItemsPromises);
    setPodCast(fetchedItems);
  }
      



      setFeeds((prevFeeds) => [...prevFeeds, ...listFeeds.savedPosts]); // Append new posts
      setOffset(prevOffset => prevOffset + listFeeds.savedPosts.length); // Update offset
      const initialLikedPosts = {};
      const intialFavourites = {};
      listFeeds.savedPosts.forEach(post => {
        // Check if userlike array contains an object with isliked equal to 1
        if (post.userlike.length > 0 && post.userlike[0].isliked === 1) {
          initialLikedPosts[post._id] = true; // User liked the post
        } else {
          initialLikedPosts[post._id] = false; // User did not like the post
        }
        if (post.favouritemember.length > 0 && post.favouritemember[0].isfavourite === 1) {
          intialFavourites[post.user[0]._id] = true;
        } else {
          intialFavourites[post.user[0]._id] = false;
        }
      });
      setLikedPosts(initialLikedPosts);
      setFavourites(intialFavourites);

    }

    setLoading(false);

  }

  return (
    <div>
      <div className="position-relative">

        <button
          className={podCast?.length > 2 ? "arrow left-arrow position-absolute top-50 start-0 translate-middle-y z-3" : "d-none"}
          onClick={scrollLeft}
        >
          ‹
          
        </button>
        <div
          ref={sliderRef}
          className="d-flex overflow-auto slider-section  gap-3"
          style={{ scrollBehavior: 'smooth', width: '100%' }}
        >
          {podCast?.map((podcast, index) => {

            return (
              <div key={podcast?._id || index} className="col-12 col-sm-6 col-md-4 mb-4">
                <div className="save-div d-flex flex-column align-items-start community-card">
                  <div className="position-relative w-100 mb-2">

                    <img
                      src={podcast.imageUrl}
                      alt="Podcast thumbnail"
                      className="img-fluid rounded video-img"
                    />

                    <div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>

                    <button
                      type="button"
                      className="play-bttn position-absolute top-50 start-50 translate-middle"
                      onClick={() => {
                        handlePlay(podcast?.videoUrl)
                        
                      }}
                    >
                      <img src={playimg} alt="Play icon" className="play-img-overlay" />
                    </button>

                  </div>

                  
                  <span className="second-name text-muted">{podcast?.title}</span>
                </div>
              </div>
            );
          })}


        </div>
        <button
          className={podCast?.length > 2 ? "arrow right-arrow position-absolute top-50 end-0 translate-middle-y z-3" : "d-none"}
          onClick={scrollRight}
        >
          ›
          
        </button>
      </div>
      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <Spinner />
        </div>
      ) : (Feeds.map((post, index) => {
        return (
          <ListFeed key={post._id} post={post} index={index}
            ref={index === Feeds.length - 1 ? lastPostRef : null}
            favourites={favourites} showFavourite={showFavourite}
            userData={userData} setShow={setShow}
            DeletPost={DeletPost} showReport={showReport}
            likedPosts={likedPosts} handleLike={handleLike}
            savedPost={savedPost} handleshortlist={handleshortlist}
            comment={comment} handleCommentChange={handleCommentChange}
             maxCommentLength={MAX_COMMENT_LENGTH}
                   commentLimit={characterLimit[post._id] || {
                    isOverLimit: false,
                    remaining: MAX_COMMENT_LENGTH,
                    limitedText: ''
                  }}
            handleCommentSubmit={handleCommentSubmit} handleEdit={handleEdit}
            handleCommentClear={handleCommentClear}>
          </ListFeed>
        )
      })


      )}
      {isPodCastPlay ? <PodCast isPodCastPlay={isPodCastPlay} handleClose={handleClose} podUrl={currentVideoUrl} /> : null}
      {
        DiscussionStatus ? <CreateDiscussion openPop={open} closePop={ClosePopup} EditStatus={EditStatus} Organiationid={Organiationid} fetchAllFeeds={fetchAllFeeds} source="profile" EditFeed={EditFeed}/>:(<CreatePost openPop={open} closePop={ClosePopup} EditStatus={EditStatus} EditFeed={EditFeed} fetchAllFeeds={fetchAllFeeds}></CreatePost>)
      }
      
      <ReportPost showReport={showreport} HideReport={HideReport} reportId={reportId}></ReportPost>
      <MakeFavourite showFavourite={showfav} HideFavourite={HideFavourite} favouriteUserId={favouriteUserId} toggleFavourite={toggleFavourite} FavStatus={FavStatus}></MakeFavourite>
       {isConfirm && (<Confirmpopup 
                      isConfirm={isConfirm}
                      DeletPostid={DeletPostid} 
                      handleDelete={handleDelete}
                      type="post"
                      CancelPopup={() => { 
                        setConfirm(false);
                      }} 
                                        
                    />)}        
      {isSucess && (<ResponsePopup
        isSucess={isSucess}
        CancelPopup={() => {
          SetSucess(false);
        }}
        message={ResponseMessage}
      />)}
    </div>
  );

};
export default SavedPost;
